import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ga4PageView, initGa4 } from "../utils/ga4";

/**
 * Loads GA4 when VITE_GA_MEASUREMENT_ID is set and sends page_view on SPA navigations.
 * Do not also paste the gtag snippet into index.html — that would double-count hits.
 */
export function GoogleAnalytics(): null {
  const location = useLocation();
  const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID?.trim();

  useEffect(() => {
    if (!measurementId) return;
    initGa4(measurementId);
  }, [measurementId]);

  useEffect(() => {
    if (!measurementId) return;
    ga4PageView(`${location.pathname}${location.search}`);
  }, [measurementId, location.pathname, location.search]);

  return null;
}
